module.exports = __webpack_public_path__ + "img/articles.48842949.png";